/* tslint:disable */
/* eslint-disable */
/* @relayHash 085a44b57ee7400434a0c2f8badcde54 */

import { ConcreteRequest } from "relay-runtime";
export type USER_ROLE = "ADMIN" | "COMMENTER" | "MEMBER" | "MODERATOR" | "STAFF" | "%future added value";
export type DemoteMemberInput = {
    userID: string;
    siteIDs: Array<string>;
    clientMutationId: string;
};
export type DemoteMemberMutationVariables = {
    input: DemoteMemberInput;
};
export type DemoteMemberMutationResponse = {
    readonly demoteMember: {
        readonly user: {
            readonly id: string;
            readonly role: USER_ROLE;
            readonly membershipScopes: {
                readonly sites: ReadonlyArray<{
                    readonly id: string;
                    readonly name: string;
                }> | null;
            } | null;
        };
        readonly clientMutationId: string;
    };
};
export type DemoteMemberMutation = {
    readonly response: DemoteMemberMutationResponse;
    readonly variables: DemoteMemberMutationVariables;
};



/*
mutation DemoteMemberMutation(
  $input: DemoteMemberInput!
) {
  demoteMember(input: $input) {
    user {
      id
      role
      membershipScopes {
        sites {
          id
          name
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v2 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DemoteModeratorPayload",
            "kind": "LinkedField",
            "name": "demoteMember",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMembershipScopes",
                            "kind": "LinkedField",
                            "name": "membershipScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Site",
                                    "kind": "LinkedField",
                                    "name": "sites",
                                    "plural": true,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DemoteMemberMutation",
            "selections": (v2 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DemoteMemberMutation",
            "selections": (v2 /*: any*/)
        },
        "params": {
            "id": "085a44b57ee7400434a0c2f8badcde54",
            "metadata": {},
            "name": "DemoteMemberMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '912d1a0e8a54b241466e14a9c739049c';
export default node;
